/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Kind_Dove_TrotInputs */

const en_bold_kind_dove_trot = /** @type {(inputs: Bold_Kind_Dove_TrotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All pipelines finished. Results are ready.`)
};

const de_bold_kind_dove_trot = /** @type {(inputs: Bold_Kind_Dove_TrotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Pipelines abgeschlossen. Ergebnisse sind bereit.`)
};

/**
* | output |
* | --- |
* | "All pipelines finished. Results are ready." |
*
* @param {Bold_Kind_Dove_TrotInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_kind_dove_trot = /** @type {((inputs?: Bold_Kind_Dove_TrotInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Kind_Dove_TrotInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_kind_dove_trot(inputs)
	return de_bold_kind_dove_trot(inputs)
});